const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0_4363_65121)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6 30.8875C6 30.9125 5.97968 30.95 5.93903 31H5.62404C5.61049 30.9833 5.51565 30.8708 5.33953 30.6624C5.1634 30.4539 5.01098 30.2747 4.88228 30.1246C4.75357 29.9746 4.57067 29.7203 4.33358 29.3618C4.09648 29.0033 3.88649 28.6657 3.70359 28.3489C3.52069 28.0321 3.3073 27.6111 3.06343 27.0859C2.81957 26.5607 2.60957 26.0396 2.43344 25.5227C2.25732 25.0058 2.07103 24.3847 1.87458 23.6594C1.67813 22.9341 1.52572 22.2005 1.41733 21.4585C1.30895 20.7165 1.21072 19.8704 1.12266 18.92C1.0346 17.9696 0.993952 16.9942 1.00073 15.9937C1.00073 10.0663 2.23361 5.43935 4.69938 2.11296C4.85518 1.90454 5.00082 1.72113 5.1363 1.56273C5.27179 1.40434 5.38356 1.27094 5.47162 1.16257C5.55968 1.05419 5.61049 0.999998 5.62404 0.999998H5.93903C5.97968 1.05002 6 1.08754 6 1.11255C6 1.15423 5.93226 1.26261 5.79678 1.43768C5.6613 1.61275 5.48517 1.85869 5.2684 2.17549C5.05163 2.49229 4.80776 2.88829 4.5368 3.36348C4.26583 3.83868 3.99148 4.43476 3.71375 5.15173C3.43601 5.86869 3.17859 6.66486 2.9415 7.54022C2.70441 8.41559 2.50119 9.46603 2.33183 10.6915C2.16248 11.917 2.0541 13.2343 2.00668 14.6432C1.99313 14.96 1.98636 15.4143 1.98636 16.0063C1.98636 19.2493 2.30474 22.0838 2.9415 24.5098C3.57826 26.9358 4.56051 28.995 5.88823 30.6874C5.96274 30.7874 6 30.8541 6 30.8875Z",
  fill: "#1E3F6B",
  stroke: "#1E3F6B",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("rect", {
  x: -0.5,
  y: 0.5,
  width: 7,
  height: 9,
  transform: "matrix(1 0 0 -1 7 13)",
  stroke: "#0081CC"
}), /*#__PURE__*/React.createElement("rect", {
  x: -0.5,
  y: 0.5,
  width: 7,
  height: 9,
  transform: "matrix(1 0 0 -1 7 29)",
  stroke: "#0081CC"
}), /*#__PURE__*/React.createElement("rect", {
  x: -0.5,
  y: 0.5,
  width: 7,
  height: 9,
  transform: "matrix(1 0 0 -1 19 13)",
  stroke: "#0081CC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.7988 24.8241C20.7988 24.6257 20.8596 24.4529 20.9812 24.3057C21.1092 24.1585 21.2692 24.0593 21.4612 24.0081C21.4868 24.0017 21.5284 23.9985 21.586 23.9985C21.9188 23.9985 22.162 24.1297 22.3156 24.3921C22.3988 24.5201 22.4404 24.6641 22.4404 24.8241C22.4404 25.0033 22.386 25.1665 22.2772 25.3137C22.1748 25.4545 22.034 25.5537 21.8548 25.6113C21.7972 25.6241 21.7204 25.6305 21.6244 25.6305C21.4196 25.6305 21.2436 25.5697 21.0964 25.4481C20.898 25.2945 20.7988 25.0865 20.7988 24.8241Z",
  fill: "#1E3F6B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.8645 24.8241C23.8645 24.6257 23.9253 24.4529 24.0469 24.3057C24.1749 24.1585 24.3349 24.0593 24.5269 24.0081C24.5525 24.0017 24.5941 23.9985 24.6517 23.9985C24.9845 23.9985 25.2277 24.1297 25.3813 24.3921C25.4645 24.5201 25.5061 24.6641 25.5061 24.8241C25.5061 25.0033 25.4517 25.1665 25.3429 25.3137C25.2405 25.4545 25.0997 25.5537 24.9205 25.6113C24.8629 25.6241 24.7861 25.6305 24.6901 25.6305C24.4853 25.6305 24.3093 25.5697 24.1621 25.4481C23.9637 25.2945 23.8645 25.0865 23.8645 24.8241Z",
  fill: "#1E3F6B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.9301 24.8241C26.9301 24.6257 26.9909 24.4529 27.1125 24.3057C27.2405 24.1585 27.4005 24.0593 27.5925 24.0081C27.6181 24.0017 27.6597 23.9985 27.7173 23.9985C28.0501 23.9985 28.2933 24.1297 28.4469 24.3921C28.5301 24.5201 28.5717 24.6641 28.5717 24.8241C28.5717 25.0033 28.5173 25.1665 28.4085 25.3137C28.3061 25.4545 28.1653 25.5537 27.9861 25.6113C27.9285 25.6241 27.8517 25.6305 27.7557 25.6305C27.5509 25.6305 27.3749 25.5697 27.2277 25.4481C27.0293 25.2945 26.9301 25.0865 26.9301 24.8241Z",
  fill: "#1E3F6B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.0305 1.02502C26.0102 1.0417 26 1.0834 26 1.15013L26.0203 1.17515C26.0339 1.18349 26.044 1.196 26.0508 1.21268C26.0576 1.22936 26.0677 1.24604 26.0813 1.26272L26.1219 1.31276C26.4877 1.7965 26.8231 2.28023 27.1279 2.76397C27.4327 3.24771 27.7714 3.92744 28.144 4.80317C28.5166 5.6789 28.8316 6.61301 29.089 7.6055C29.3464 8.598 29.5632 9.82402 29.7393 11.2836C29.9154 12.7431 30.0035 14.3153 30.0035 16H30.9993C31.006 15.0075 30.9654 14.0317 30.8773 13.0726C30.7893 12.1134 30.6911 11.2669 30.5827 10.5329C30.4743 9.799 30.3219 9.06506 30.1254 8.33111C29.929 7.59717 29.7427 6.97581 29.5666 6.46706C29.3904 5.9583 29.1804 5.4412 28.9366 4.91576C28.6927 4.39033 28.4793 3.96914 28.2964 3.65221C28.1135 3.33528 27.9035 2.9975 27.6664 2.63887C27.4293 2.28023 27.2464 2.02586 27.1177 1.87573C26.989 1.72561 26.8366 1.54629 26.6605 1.33778C26.4843 1.12928 26.3895 1.01668 26.376 1H26.2235H26.1626C26.0948 1 26.0508 1.00834 26.0305 1.02502Z",
  fill: "#1E3F6B",
  stroke: "#1E3F6B",
  strokeWidth: 0.5
}));

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_4363_65121"
}, /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  fill: "white"
})));

const SvgEquationMatrix4 = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2, _ref3);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEquationMatrix4, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/equation-matrix-4.155e78b0.svg";
export { ForwardRef as ReactComponent };